<template>
  <div></div>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'PaymentLinkShower',
  components: {},
  props: {},
  data() {
    return {
      eventsIds: [],
    }
  },
  mounted() {
    const id = this.$Events.handleEvent(
      'uncompleted_transaction_available',
      this.onUncompletedTransaction,
    )
    this.eventsIds.push(id)
  },
  beforeUnmount() {
    this.eventsIds.forEach(this.$Events.removeHandler)
  },
  methods: {
    onUncompletedTransaction(data) {
      if (!data.paymentUrl) return
      this.openUrl(data.paymentUrl)
    },
    openUrl(url) {
      this.$Events.dispatchEvent('finish_loading')

      setTimeout(() => {
        this.$Events.dispatchEvent('url_opening_required', {
          url,
          title: 'Redirection pour continuer le paiement',
          body: `Si la page de paiement ne souvre pas automatiquement, <a target="_blank" class="underline" href="${url}"> veuillez cliquer ici pour confirmer le paiement </a>`,
        })
      }, 1000)
    },
  },
  computed: {},
})
</script>
